import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider.js";
import {
  buildSupplierInput,
  cadastroFromSupplier
} from "../lib/cadastro-form.js";
import type { Supplier } from "../types.js";
import { CadastroComSkus } from "./cadastro/CadastroComSkus.js";

/**
 * Cadastro › Fornecedores (Design.md §8.2). Rota ADMIN-only (RequireRole,
 * decisão 5). Campos Nome · Endereço · Lead Time + tabela de SKUs. Mutações são
 * ADMIN-only no backend (suppliers.ts).
 */
export function FornecedoresPage(): ReactNode {
  const { api, me } = useAuth();
  const canMutate = me?.role === "ADMIN";

  return (
    <CadastroComSkus<Supplier>
      kind="supplier"
      title="Fornecedores"
      subtitle="Cadastro · acesso restrito (Admin)"
      newLabel="Novo fornecedor"
      extraLabel="Lead Time (dias)"
      extraColumnHeader="Lead Time"
      extraInputType="number"
      canMutate={canMutate}
      list={async () => (await api.listSuppliers()).suppliers}
      save={async (id, values) => {
        const input = buildSupplierInput(values);
        if (id === null) {
          await api.createSupplier(input);
        } else {
          await api.updateSupplier(id, input);
        }
      }}
      remove={async (id) => {
        await api.deleteSupplier(id);
      }}
      getId={(s) => s.id}
      getName={(s) => s.name}
      getAddress={(s) => s.address}
      getExtraDisplay={(s) => `${s.leadTimeDays} dia${s.leadTimeDays === 1 ? "" : "s"}`}
      getSkuCount={(s) => s.skus.length}
      toForm={cadastroFromSupplier}
    />
  );
}
